import { getTableColumns } from 'helpers';

const VersionColumns = [
  ['pioChangeNumber', 'number', 'PIO #', 'center', true],
  ['versionNo', 'number', 'Version #', 'center', true],
  ['versionDesc', 'string', 'Description', 'left', true],
  ['versionDate', 'date', 'Version Date', 'center', true],
  ['activationDate', 'date', 'Release Date & Time (12 hr)', 'center', true],
  ['endDate', 'date', 'Version End Date', 'center', true],
  ['reviewType', 'string', 'Review Type', 'left', true],
  ['collectType', 'string', 'Collect', 'left', true],
  ['requiredByDate', 'date', 'Required By Date & Time (12 hr)', 'center', true],
  ['comments', 'string', 'Comments', 'left', true]
];


export default getTableColumns(VersionColumns);
